import { AxiosRequestConfig } from 'axios'
import {
  File as Data,
  FileCollection as Collection,
} from '@/typings/api/File'
import {
  BaseApiResponse as BR,
} from '@/typings/common'

import { BaseLkApiAuth } from '@/api/BaseApiAuth'


export class LkFormTemplateApi extends BaseLkApiAuth<Data, Collection> {
  protected readonly endpoint = 'form_templates';

  public getTemplate(formTemplateId: number) {
    const path = `${formTemplateId}/template`
    const [url] = this.getUrl(path)
    return url
  }

  public getStatus(formTemplateId: number, formDataId: number, config: AxiosRequestConfig = {}) {
    const path = `${formTemplateId}/template/status?form_data_id=${formDataId}`
    const [url] = this.getUrl(path)
    return this.request<never, BR<Data['raw_file']>>('GET', url, { ...config })
  }

  public generate(formTemplateId: number, formDataId: number, config: AxiosRequestConfig = {}) {
    const path = `${formTemplateId}/template/generate?form_data_id=${formDataId}`
    const [url] = this.getUrl(path)
    return this.request<never, BR<Data['raw_file']>>('POST', url, { ...config })
  }

  public download(formTemplateId: number, formDataId: number) {
    const path = `${formTemplateId}/template/download?form_data_id=${formDataId}`
    const [url] = this.getUrl(path)
    return url
  }

  public uploadTemplate(formTemplateId: number, file: File, config: AxiosRequestConfig = {}) {
    const path = `${formTemplateId}/template`
    const [url] = this.getUrl(path)
    const data = new FormData()
    data.append('file', file)
    return this.request<never, BR<Data['raw_file']>>('POST', url, { data, ...config })
  }
}
